<template>
  <main class="service-status">
    <h1>Informasi layanan SekolahDesain</h1>
    <p v-if="salesClosed">Pembelian kelas, langganan, dan top-up baru telah dihentikan.</p>
    <p v-if="registrationClosed">Pendaftaran member baru juga telah dihentikan.</p>
    <p>Member lama tetap dapat masuk, mengakses kelas yang dimiliki, dan mengunduh sertifikat yang tersedia. Perubahan ini tidak menghapus akun atau kepesertaan Anda.</p>
    <p>Sudah melakukan pembayaran atau memiliki voucher pembelian lama? Hubungi admin untuk penyelesaiannya. Jangan melakukan transfer untuk pembelian baru.</p>
    <nav aria-label="Bantuan layanan">
      <router-link to="/my-classes">Kelas saya</router-link>
      <router-link to="/login">Masuk</router-link>
      <router-link to="/forgot-password">Lupa kata sandi</router-link>
      <a href="https://wa.me/6285155421080">Hubungi admin</a>
    </nav>
  </main>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import { salesClosed, registrationClosed } from '@/utils/ServiceAvailability'
export default defineComponent({ data: () => ({ salesClosed, registrationClosed }) })
</script>
<style scoped>
.service-status { max-width: 48rem; margin: 2rem auto; padding: 1.5rem; color: #212121; }
h1 { font-size: 1.75rem; font-weight: 700; margin-bottom: 1rem; }
p { margin-bottom: 1rem; line-height: 1.6; }
nav { display: flex; flex-wrap: wrap; gap: 1rem; }
a { color: #00446e; text-decoration: underline; padding: .75rem 0; }
a:focus-visible { outline: 2px solid #00446e; outline-offset: 4px; }
</style>
